module.exports = __webpack_public_path__ + "static/media/img4.256eb2d2.jpeg";